<template>
    <div class="account-connessioni">
        <msp-app-bar title="Connessioni"></msp-app-bar>
        <v-container max-width="450px">
            <div v-if="atleta" class="pa-colonne">
                <v-alert :type="message.type" dismissible v-if="message.text">{{message.text}}</v-alert>
                <v-card class="mb-1">
                    <v-card-text>Collega i tuoi account per avere i dati sincronizzati con CoachPeaking...</v-card-text>
                </v-card>
                <v-card class="mb-1" v-for="provider in providers" :key="provider.slug">
                    <v-card-text>
                        <div class="connessione-row">
                            <span class="connessione-icon">
                                <img :src="'/img/devices/' + provider.icon" :alt="provider.label">
                            </span>
                            <span class="connessione-name">{{ provider.label }}</span>
                            <div class="connessione-switch">
                                <v-switch
                                    :key="provider.slug + '-' + switchKey"
                                    class="mt-0 pt-0"
                                    hide-details
                                    inset
                                    color="primary"
                                    :aria-label="provider.label"
                                    :input-value="autorizzazioni[provider.slug].autorizzato"
                                    :loading="autorizzazioni[provider.slug].isLoading"
                                    :disabled="autorizzazioni[provider.slug].isLoading"
                                    @change="toggleConnection(provider.slug)"
                                ></v-switch>
                                <span v-if="autorizzazioni[provider.slug].reauth" class="text-caption deep-orange--text text--darken-3">Da ricollegare</span>
                                <span v-else-if="autorizzazioni[provider.slug].autorizzato" class="text-caption">Connesso</span>
                                <span v-else class="text-caption grey--text">Disconnesso</span>
                            </div>
                        </div>
                        <div v-if="autorizzazioni[provider.slug].reauth" class="mt-3">
                            <v-alert type="warning" color="deep-orange darken-3" border="left" colored-border dense class="mb-2">
                                {{ provider.label }} ha aggiornato il sistema di collegamento: ricollega l'account per continuare a ricevere i dati.
                            </v-alert>
                            <v-btn
                                small
                                color="primary"
                                :disabled="autorizzazioni[provider.slug].isLoading"
                                @click="connect(provider.slug)"
                            >Ricollega {{ provider.label }}</v-btn>
                        </div>
                        <msp-recupera-dati-strava
                            v-if="provider.slug === 'strava' && autorizzazioni.strava.autorizzato && !autorizzazioni.strava.isLoading"
                            class="mt-5 text-center"
                            :atleta-id="atleta.id"
                        />
                    </v-card-text>
                </v-card>
            </div></v-container>
    </div>

</template>

<script type="module">
import mspAppBar from "@components/MspAppBar.vue";
import env from "@mixins/environment.js";
import _api from "@mixins/api.js";
import mspRecuperaDatiStrava from "@components/MspRecuperaDatiStrava.vue";
import CP_CONFIG from "@src/js/msp/config.js";
let popupWorkout;

// Verifica e disconnessione passano da api/v2/connection.php per tutti i provider; cambia
// solo l'URL di autorizzazione. Ogni callback risponde al popup con 'MSP_AUTH_<SLUG>' o
// 'MSP_AUTH_ERROR'.
const SLUGS = ['garmin', 'strava', 'polar', 'coros', 'wahoo', 'suunto'];

const component = {
    mixins: [
        env,
    ],
    components: {
        mspAppBar,
        mspRecuperaDatiStrava,
    },
    data () {
        const autorizzazioni = {};
        SLUGS.forEach((slug) => {
            autorizzazioni[slug] = {
                autorizzato: false,
                // Connessione da rifare (es. Garmin ancora su OAuth1).
                reauth: false,
                isLoading: false,
            };
        });
        return {
            atleta: null,
            autorizzazioni,
            // Slug del provider per cui e' aperto il popup, per il messaggio MSP_AUTH_ERROR generico.
            connectingSlug: null,
            // Timer che rileva la chiusura manuale del popup; switchKey forza il remount degli switch
            // (Vuetify 2 tiene uno stato interno che diverge da input-value se l'operazione viene annullata).
            popupWatcher: null,
            // Timer che rilegge dal server lo stato del collegamento in corso (vedi controllaCollegamentoInCorso).
            controlloCollegamento: null,
            switchKey: 0,

            message: {
                type: null,
                text: null,
            },
        }
    },
    mounted () {
        SLUGS.forEach((slug) => this.verificaAutorizzazione(slug));

        this.messageHandler = (event) => {
            // Accetta solo messaggi provenienti dal popup aperto da questa pagina.
            if (!popupWorkout || event.source !== popupWorkout) {
                return;
            }
            if (typeof event.data !== 'string' || !event.data.startsWith('MSP_')) {
                return;
            }
            this.stopPopupWatcher();
            this.stopControlloCollegamento();

            const slug = SLUGS.find((s) => event.data === 'MSP_AUTH_' + s.toUpperCase());
            if (slug) {
                popupWorkout.close();
                this.connectingSlug = null;
                this.autorizzazioni[slug].isLoading = false;
                this.autorizzazioni[slug].autorizzato = true;
                // Rilegge lo stato completo (es. reauth dopo la ri-autorizzazione Garmin).
                this.verificaAutorizzazione(slug);
                return;
            }

            if (event.data === 'MSP_AUTH_ERROR') {
                popupWorkout.close();
                const slugInErrore = this.connectingSlug || 'garmin';
                this.connectingSlug = null;
                const nome = slugInErrore.charAt(0).toUpperCase() + slugInErrore.slice(1);
                this.autorizzazioni[slugInErrore].isLoading = false;
                this.verificaAutorizzazione(slugInErrore).finally(() => { this.switchKey++; });
                this.message = {
                    type: "error",
                    text: "Autorizzazione " + nome + " non riuscita. Riprova.",
                };
            }

            if (event.data === 'MSP_SENT_GARMIN') {
                popupWorkout.close();
                this.autorizzazioni.garmin.isLoading = false;
            }
        };
        window.addEventListener("message", this.messageHandler, false);

        this.ritornoHandler = () => {
            if (document.visibilityState === 'visible') {
                this.controllaCollegamentoInCorso();
            }
        };
        document.addEventListener("visibilitychange", this.ritornoHandler);
        window.addEventListener("focus", this.ritornoHandler);
        window.addEventListener("pageshow", this.ritornoHandler);

        this.init();

    },
    computed: {
        providers () {
            return [
                { slug: 'garmin', label: 'Garmin', icon: 'garmin-icon.png' },
                { slug: 'strava', label: 'Strava', icon: 'strava-icon.png' },
                { slug: 'polar', label: 'Polar', icon: 'polar-icon.png' },
                { slug: 'coros', label: 'Coros', icon: 'coros-icon.png' },
                { slug: 'wahoo', label: 'Wahoo', icon: 'wahoo-icon.png' },
                { slug: 'suunto', label: 'Suunto', icon: 'suunto-icon.png' },
            ].filter((p) => p.slug !== 'wahoo' || this.wahooVisibile)
                .filter((p) => p.slug !== 'suunto' || this.suuntoVisibile);
        },
        // Con WAHOO_DEBUG attivo Wahoo e' visibile solo agli atleti in whitelist di test;
        // con WAHOO_DEBUG disattivo e' visibile a tutti.
        wahooVisibile () {
            if (!CP_CONFIG.WAHOO_DEBUG) {
                return true;
            }
            return Array.isArray(CP_CONFIG.WAHOO_DEBUG_WHITELIST)
                && !!this.atleta
                && CP_CONFIG.WAHOO_DEBUG_WHITELIST.includes(this.atleta.id);
        },
        // Come Wahoo: con SUUNTO_DEBUG attivo visibile solo agli atleti in whitelist.
        suuntoVisibile () {
            if (!CP_CONFIG.SUUNTO_DEBUG) {
                return true;
            }
            return Array.isArray(CP_CONFIG.SUUNTO_DEBUG_WHITELIST)
                && !!this.atleta
                && CP_CONFIG.SUUNTO_DEBUG_WHITELIST.includes(this.atleta.id);
        },
    },
    beforeDestroy () {
        this.stopPopupWatcher();
        this.stopControlloCollegamento();
        window.removeEventListener("message", this.messageHandler, false);
        document.removeEventListener("visibilitychange", this.ritornoHandler);
        window.removeEventListener("focus", this.ritornoHandler);
        window.removeEventListener("pageshow", this.ritornoHandler);
    },
    methods: {
        stopPopupWatcher () {
            if (this.popupWatcher) {
                clearInterval(this.popupWatcher);
                this.popupWatcher = null;
            }
        },
        // Alla chiusura del popup (a mano, o da solo dopo il redirect finale) senza che sia arrivato il
        // postMessage (opener perso, tipico di Safari iOS o delle app che intercettano l'URL OAuth),
        // lo stato reale si legge dal server invece di assumere "non connesso".
        watchPopupClosed (popup) {
            this.stopPopupWatcher();
            this.popupWatcher = setInterval(() => {
                if (!popup.closed) {
                    return;
                }
                this.stopPopupWatcher();
                this.stopControlloCollegamento();
                const slug = this.connectingSlug;
                this.connectingSlug = null;
                if (slug && this.autorizzazioni[slug]) {
                    this.autorizzazioni[slug].isLoading = false;
                    this.verificaAutorizzazione(slug).finally(() => { this.switchKey++; });
                    return;
                }
                this.switchKey++;
            }, 500);
        },
        stopControlloCollegamento () {
            if (this.controlloCollegamento) {
                clearInterval(this.controlloCollegamento);
                this.controlloCollegamento = null;
            }
        },
        // Il callback del provider puo' arrivare in un browser diverso da quello che ha aperto il popup
        // (app del provider che intercetta l'URL di autorizzazione, SPA installata in home su iOS):
        // niente postMessage, e il popup resta aperto sulla pagina del provider. Lo stato si rilegge dal
        // server al ritorno sulla pagina (visibilitychange/focus/pageshow) e a intervalli, per i casi in
        // cui la pagina non perde mai il focus (popup mostrato sopra la SPA installata).
        avviaControlloCollegamento () {
            this.stopControlloCollegamento();
            const inizio = Date.now();
            this.controlloCollegamento = setInterval(() => {
                if (Date.now() - inizio > 10 * 60 * 1000) {
                    this.stopControlloCollegamento();
                    return;
                }
                this.controllaCollegamentoInCorso();
            }, 4000);
        },
        controllaCollegamentoInCorso () {
            const slug = this.connectingSlug;
            if (!slug || !this.autorizzazioni[slug]) {
                return;
            }
            _api(this.connectionUrl(slug), "GET")
                .then((result) => {
                    const data = result.success ? result.data : null;
                    // reauth: una connessione Garmin "Da ricollegare" risulta gia' connected, il
                    // collegamento e' concluso solo quando reauth torna false.
                    if (!data || !data.connected || data.reauth || this.connectingSlug !== slug) {
                        return;
                    }
                    this.stopPopupWatcher();
                    this.stopControlloCollegamento();
                    this.connectingSlug = null;
                    try {
                        if (popupWorkout && !popupWorkout.closed) {
                            popupWorkout.close();
                        }
                    } catch (e) {
                        // popup non piu' accessibile
                    }
                    this.autorizzazioni[slug].isLoading = false;
                    this.autorizzazioni[slug].autorizzato = true;
                    this.autorizzazioni[slug].reauth = false;
                    this.switchKey++;
                })
                .catch(() => {});
        },
        init () {
            this.loadAtleta().then(
                (result)=>{
                    if (result && result.success) {
                        this.atleta = {...result.data};
                    }
                }
            );

        },
        loadAtleta () {
            let url = this.api_base_url+"/api/v2/atleta.php";

            return new Promise((resolve,reject)=>{
                _api(url, "GET")
                    .then((result)=>{
                        if (result.success) {
                            resolve(result);
                        } else {
                            resolve(null);
                        }
                    })
                    .catch((error)=>{
                        reject(error);
                    });
            });
        },

        connectionUrl (slug) {
            return this.api_base_url + "/api/v2/connection.php?provider=" + slug;
        },

        verificaAutorizzazione (slug) {
            this.autorizzazioni[slug].isLoading = true;
            return _api(this.connectionUrl(slug), "GET")
                .then((result)=>{
                    this.autorizzazioni[slug].isLoading = false;
                    const data = result.success ? result.data : null;
                    this.autorizzazioni[slug].autorizzato = !!(data && data.connected);
                    this.autorizzazioni[slug].reauth = !!(data && data.reauth);
                })
                .catch(()=>{
                    this.autorizzazioni[slug].isLoading = false;
                    this.autorizzazioni[slug].autorizzato = false;
                    this.autorizzazioni[slug].reauth = false;
                });
        },

        disconnect (slug) {
            this.autorizzazioni[slug].isLoading = true;
            return _api(this.connectionUrl(slug), "DELETE")
                .then((result)=>{
                    this.autorizzazioni[slug].isLoading = false;
                    if (result.success) {
                        this.autorizzazioni[slug].autorizzato = false;
                        this.autorizzazioni[slug].reauth = false;
                    }
                    return result;
                })
                .catch(()=>{
                    this.autorizzazioni[slug].isLoading = false;
                })
                .finally(()=>{
                    this.switchKey++;
                });
        },

        toggleConnection (slug) {
            if (this.autorizzazioni[slug].isLoading) return;
            if (this.autorizzazioni[slug].autorizzato) {
                this.disconnect(slug);
            } else {
                this.connect(slug);
            }
        },

        connect (slug) {
            this.autorizzazioni[slug].isLoading = true;
            this.connectingSlug = slug;
            popupWorkout = this.apriPopupAutorizzazione(this.authUrl(slug));
            if (!popupWorkout) {
                this.autorizzazioni[slug].isLoading = false;
                this.switchKey++;
                return;
            }
            this.avviaControlloCollegamento();
        },

        apriPopupAutorizzazione: function (url) {
            const windowFeatures = "menubar=no,location=no,resizable=no,scrollbars=yes,status=no,width=400,height=600";
            const popup = window.open(url, 'popupWorkout', windowFeatures);
            // Safari (in particolare con "Blocca finestre popup" attivo) non genera un errore:
            // restituisce null oppure una finestra già "closed". Va rilevato esplicitamente,
            // altrimenti isLoading resta true per sempre senza alcun feedback all'utente.
            if (!popup || popup.closed || typeof popup.closed === "undefined") {
                this.message = {
                    type: "error",
                    text: "Il browser ha bloccato la finestra di autorizzazione. Su Safari: consenti i popup per questo sito (Safari → Impostazioni sito web → Finestre popup) e riprova.",
                };
                return null;
            }
            this.message = { type: null, text: null };
            this.watchPopupClosed(popup);
            return popup;
        },

        // Ingresso unico lato server: autentica e reindirizza al provider con uno state firmato
        // (vedi connection/authorize.php). Client id, scope e redirect_uri stanno nel backend.
        authUrl (slug) {
            return this.api_base_url
                + "/connection/authorize.php?provider=" + encodeURIComponent(slug)
                + "&origin=" + encodeURIComponent(window.location.origin);
        },
    },
}
export default component
</script>
<style lang="scss">
.account-connessioni {
    .connessione-row {
        display: flex;
        align-items: center;
        gap: 0.75em;
    }
    .connessione-icon {
        flex: none;
        display: flex;
        width: 44px;
        height: 44px;
        border-radius: 15px;
        overflow: hidden;
        background: #fff;
        border: 1px solid #0005;

        img {
            display: block;
            max-width: 100%;
            max-height: 100%;
            object-fit: cover;
        }
    }
    .connessione-name {
        flex: 1;
    }
    .connessione-switch {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

}
</style>
